///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

import { Box3, Box3Helper } from "three";
import { IComponent, components, Viewer } from "@inweb/viewer-three";

class ExtentsHelperComponent implements IComponent {
  private viewer: Viewer;
  private boxHelper: Box3Helper;

  constructor(viewer: Viewer) {
    this.boxHelper = new Box3Helper(new Box3(), "#ff0000");
    this.viewer = viewer;
    this.viewer.on("geometryend", this.syncHelper);
    this.viewer.on("clear", this.syncHelper);
    this.viewer.on("explode", this.syncHelper);
    this.viewer.on("hide", this.syncHelper);
    this.viewer.on("isolate", this.syncHelper);
    this.viewer.on("show", this.syncHelper);
    this.viewer.on("showall", this.syncHelper);
  }

  dispose() {
    this.boxHelper.removeFromParent();
    this.boxHelper.dispose();

    this.viewer.off("geometryend", this.syncHelper);
    this.viewer.off("clear", this.syncHelper);
    this.viewer.off("explode", this.syncHelper);
    this.viewer.off("hide", this.syncHelper);
    this.viewer.off("isolate", this.syncHelper);
    this.viewer.off("show", this.syncHelper);
    this.viewer.off("showall", this.syncHelper);
  }

  syncHelper = () => {
    this.boxHelper.removeFromParent();

    if (this.viewer.extents.isEmpty()) return;

    this.boxHelper.box = this.viewer.extents.clone();
    this.viewer.helpers.add(this.boxHelper);
  };
}

components.registerComponent("ExtentsHelperComponent", (viewer) => new ExtentsHelperComponent(viewer));
